// components/TrustedPartners.tsx
"use client";

import Image from "next/image";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import Heading from "../heading";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTrustedPartners } from '../../redux/slices/common';

const ROW_PATTERN = [7, 6, 6, 7];

const chunkByPattern = (arr, pattern = ROW_PATTERN) => {
    const rows = [];
    let i = 0;
    for (const n of pattern) {
        if (i >= arr.length) break;
        rows.push(arr.slice(i, i + n));
        i += n;
    }
    return rows;
};

export default function TrustedPartners({
    data, onClick
}) {
    const dispatch = useDispatch();
    const { title, subtitle, } = data;
    const { trustesPartnersRes } = useSelector((state) => state.common);
    const [loader, setLoader] = useState(true);
    const [logos, setRows] = useState([]);

    const rows = chunkByPattern(logos);

    useEffect(() => {
        dispatch(getTrustedPartners());
        setLoader(true);
    }, [dispatch])

    useEffect(() => {
        if (trustesPartnersRes) {
            setLoader(false);
            if (trustesPartnersRes?.status === 1) {
                setRows(trustesPartnersRes?.ourPartners ?? []);
            } else {
                setRows([]);
            }
        }
    }, [trustesPartnersRes])

    const Tile = (l) => (
        <Paper
            key={l?.name}
            elevation={0}
            sx={{
                height: 72,
                borderRadius: 2.5,
                border: "1px solid #E6E9EF",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
                boxShadow: "0 6px 14px rgba(16,24,40,.06)",
                transition: "transform .18s ease, box-shadow .18s ease",
                "&:hover": { transform: "translateY(-2px)", boxShadow: "0 10px 22px rgba(16,24,40,.10)" },
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: 32,
                    maxWidth: 180,
                    filter: "grayscale(100%)",
                    opacity: 0.9,
                    "&:hover": { filter: "none", opacity: 1 },
                }}
                aria-label={l?.name}
                title={l?.name}
            >
                <Image src={`${process.env.IMAGE_BASE_URL}/${l?.image}`} alt={l?.name} fill style={{ objectFit: "contain" }} />
            </Box>
        </Paper>
    );

    return (
        <Box component="section" sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#f8f8f8" }}>
            <Container maxWidth="lg">
                {/* Heading */}
                <Heading title={title} subtitle={subtitle} />
                {/* <Stack alignItems="center" spacing={1}>
                    <Typography variant="body2" sx={{ color: "text.secondary", letterSpacing: ".02em" }}>
                        {subtitle}
                    </Typography>
                    <Box sx={{ textAlign: "center", position: "relative" }}>
                        <Typography component="h2" sx={{ fontWeight: 800, fontSize: { xs: 28, md: 40 }, lineHeight: 1.15, color: "#111" }}>
                            {title}
                        </Typography>
                        <Box component="img" src={underlineSrc} alt="" aria-hidden sx={{ mt: 1, mx: "auto", width: { xs: 140, md: 200 }, display: "block" }} />
                    </Box>
                </Stack> */}

                {/* Mobile/Tablet: auto-fit grid */}
                <Box
                    sx={{
                        display: { xs: "grid", md: "none" },
                        mt: { xs: 4, md: 6 },
                        gap: { xs: 1.5, sm: 2 },
                        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                    }}
                >
                    {logos.map(Tile)}
                </Box>

                {/* Desktop: fixed rows 7 / 6 / 6 / 7 */}
                <Box sx={{ display: { xs: "none", md: "block" }, mt: 6 }}>
                    {rows?.map((row, idx) => (
                        <Box
                            key={idx}
                            sx={{
                                display: "grid",
                                gridTemplateColumns: `repeat(${row.length}, 1fr)`,
                                gap: 2.5,
                                mb: idx === rows.length - 1 ? 0 : 2.5,
                            }}
                        >
                            {row.map(Tile)}
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
}
